import { laravelGet, laravelPut } from '../utils/laravelClient';

export const fetchPublicFeatureFlags = async () => {
  const result = await laravelGet('/feature-flags/public', { auth: 'none' });
  return result?.data ?? result;
};

export const fetchFeatureFlags = async () => {
  return laravelGet('/feature-flags', { auth: 'admin' });
};

export const fetchFeatureFlag = async (key) => {
  return laravelGet(`/feature-flags/${encodeURIComponent(key)}`, { auth: 'admin' });
};

export const updateFeatureFlag = async (key, payload) => {
  return laravelPut(`/feature-flags/${encodeURIComponent(key)}`, payload, { auth: 'admin' });
};
